// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6d4e014a","893":"bd75528d","976":"7e2c3abf"}[chunkId] + ".chunk.js";
};